import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  orderFormPrice: {},
  orderFormAmount: {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_ORDERFORM_PRICE_AMOUNT:
      return {
        ...state,
        orderFormPrice: {
          ...state.orderFormPrice,
          [action.symbol]: action.price,
          side: action.side,
        },
        orderFormAmount: {
          ...state.orderFormAmount,
          [action.symbol]: action.totalAmount,
          side: action.side,
        },
      };
    default:
      return state;
  }
};
